(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneDialogController', SpecializzazioneDialogController);

    SpecializzazioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Specializzazione'];

    function SpecializzazioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Specializzazione) {
        var vm = this;

        vm.specializzazione = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specializzazione.id !== null) {
                Specializzazione.update(vm.specializzazione, onSaveSuccess, onSaveError);
            } else {
                Specializzazione.save(vm.specializzazione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:specializzazioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
